export const TRANSLATION_PATH = (route) => {
  return `views.app.manage.devices.defaultDevices.${route}`;
};

// export const LOG_EVENT_PATH = (event) => {
//   return EVENTS.VIEWS.APP.MANAGE.DEVICES[event];
// };
